const isProduction = () => {
  const env = process.env.NODE_ENV || "development";
  return env === "production";
};

const getEnvironments = () => {
  let url;
  if (isProduction()) url = process.env.REACT_APP_BASE_URL_PRODUCTION;
  else url = process.env.REACT_APP_BASE_URL_DEVELOPMENT;

  return url || "development_env_not_found";
};

const config = {
  APP_NAME: "HOTEL BOOKING ADMIN",
  API_ROOT: getEnvironments(),
  isProduction: isProduction(),
  DEFAULT_LANG_CODE: "uz",
};

export default config;
